import { ekezetMentes } from './szoveg.ts';

/** Irodai slug-javaslat a névből: ékezet nélküli, kötőjeles, legfeljebb 60 karakter (az `offices.slug` formátuma). */
export function slugJavaslat(nev: string): string {
  return ekezetMentes(nev).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+/, '').slice(0, 60).replace(/-+$/, '');
}
